import { render, staticRenderFns } from "./ComingLottery.vue?vue&type=template&id=255dcb2a&scoped=true"
import script from "./ComingLottery.vue?vue&type=script&lang=js"
export * from "./ComingLottery.vue?vue&type=script&lang=js"
import style0 from "./ComingLottery.vue?vue&type=style&index=0&id=255dcb2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255dcb2a",
  null
  
)

export default component.exports